import TextPreview from './TextPreview'

export default TextPreview
